var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoClosed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "zonr5f1e2a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm0 1.92C6.442 1.92 1.92 6.442 1.92 12S6.442 22.08 12 22.08 22.08 17.558 22.08 12 17.558 1.92 12 1.92zm0 4.32a1.2 1.2 0 0 1 1.2 1.2v9.12a1.2 1.2 0 1 1-2.4 0V7.44a1.2 1.2 0 0 1 1.2-1.2zM6.58 8.159l2.5 3 .017.02a.993.993 0 0 1 .051.072l-.068-.092a1.01 1.01 0 0 1 .231.64 1.006 1.006 0 0 1-.15.529l-.013.02a.927.927 0 0 1-.051.07l-.017.021-2.5 3a1 1 0 1 1-1.537-1.28l1.966-2.361-1.966-2.359A1 1 0 0 1 6.58 8.16zm12.877.45a1 1 0 0 1-.128 1.41L16.95 12l2.379 1.982a1 1 0 1 1-1.28 1.536l-3-2.5A1 1 0 0 1 14.72 12a1 1 0 0 1 .328-1.017l3-2.5a1 1 0 0 1 1.409.128z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoClosed);
export default __webpack_public_path__ + "static/media/auto-closed.ad15c34edd733dd75424ddd9c11c77e0.svg";
export { ForwardRef as ReactComponent };